import { j as json } from "../../../../../../chunks/index2.js";
import { w as withOptions, o as octokit, c as cancelWorkflowRun } from "../../../../../../chunks/octokit.js";
import { I as InstallerCollection } from "../../../../../../chunks/firebase.js";
const GET = async ({ locals }) => {
  const workflows = await withOptions(octokit.rest.actions.listWorkflowRunsForRepo, {
    branch: `user/${locals.user.email}`
  });
  const workflow = workflows.data.workflow_runs[0];
  const workflowId = workflow.id;
  if (workflowId) await cancelWorkflowRun(workflowId);
  await InstallerCollection().doc(locals.user.email).set(
    {
      cancelled: true
    },
    { merge: true }
  );
  return json({
    success: true
  });
};
export {
  GET
};
